module.exports = __webpack_public_path__ + "static/media/Logo-Humano.4e7bbf39.png";